import React from "react";
import {
	Box,
	Input,
	InputGroup,
	InputLeftElement,
	Button,
	HStack,
	Badge,
	Wrap,
	WrapItem,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";

export interface TemplateCategory {
	name: string;
	count: number;
	tag?: string; // undefined for "All Templates" and "Uncategorized"
}

interface NotificationTemplateFiltersProps {
	searchQuery: string;
	onSearchChange: (query: string) => void;
	onClearFilters: () => void;
	/** Categories rendered as a horizontal filter row beneath the search box. */
	categories: TemplateCategory[];
	selectedCategory: string;
	onCategorySelect: (categoryName: string) => void;
}

const NotificationTemplateFilters: React.FC<NotificationTemplateFiltersProps> = ({
	searchQuery,
	onSearchChange,
	onClearFilters,
	categories,
	selectedCategory,
	onCategorySelect,
}) => {
	const hasActiveFilters = searchQuery.length > 0;

	return (
		<Box mb={6} p={4} bg="white" borderRadius="md" border="1px solid" borderColor="gray.200">
			<HStack spacing={4}>
				<InputGroup flex="1">
					<InputLeftElement pointerEvents="none">
						<SearchIcon color="gray.400" />
					</InputLeftElement>
					<Input
						placeholder="Sök efter mall (namn eller beskrivning)..."
						value={searchQuery}
						onChange={(e) => onSearchChange(e.target.value)}
						bg="white"
					/>
				</InputGroup>

				{hasActiveFilters && (
					<Button size="md" variant="ghost" colorScheme="red" onClick={onClearFilters}>
						Rensa filter
					</Button>
				)}
			</HStack>

			{/* Horizontal category filter — replaces the old vertical sidebar so the
			    notification view doesn't add a third column inside the settings split view. */}
			<Wrap spacing={2} mt={4}>
				{categories.map((category) => {
					const isSelected = selectedCategory === category.name;
					return (
						<WrapItem key={category.name}>
							<Button
								variant={isSelected ? "solid" : "outline"}
								colorScheme={isSelected ? "blue" : "gray"}
								onClick={() => onCategorySelect(category.name)}
								size="sm"
								fontWeight={isSelected ? "bold" : "normal"}
								borderRadius="full"
							>
								{category.name}
								<Badge
									colorScheme={isSelected ? "blue" : "gray"}
									ml={2}
									fontSize="xs"
									borderRadius="full"
								>
									{category.count}
								</Badge>
							</Button>
						</WrapItem>
					);
				})}
			</Wrap>
		</Box>
	);
};

export default NotificationTemplateFilters;
